export default "__VITE_ASSET__MQ1WYWbz__"